import React from 'react';
import PropTypes from 'prop-types';
import CheckboxInput from './formComponents/CheckboxInput';
import LoadableNumberInput from './loadableComponents/LoadableNumberInput';
import PriceFormatter from './formatterComponents/PriceFormatter';
import Tooltip from './Tooltip';
import {decodeEntities} from '../api/utils';

const Ticket = ({ ticket, inputChange }) => {
  const onChange = function(name, value) {
    const updatedValue = typeof value === 'boolean' ? (value ? 1 : 0) : value; // eslint-disable-line no-nested-ternary
    inputChange(name,
      updatedValue);
  };

  let input;
  if (ticket.maxUnits === 1) {
    input = (
<CheckboxInput
  name={ticket.serviceId}
  onChange={onChange}
  value={!!ticket.unitCount}
/>
    );
  }
  else {
    input = (
<LoadableNumberInput
  loadingWrapClass="loading-wrap-service-input"
  max={ticket.maxUnits}
  name={ticket.serviceId}
  onChange={onChange}
  value={ticket.unitCount}
/>
    );
  }

  return (
    <ul className="service">
      <li className="service__name">{decodeEntities(ticket.name)}</li>
      <li className="service__tooltip">
        <Tooltip>
          <span>{decodeEntities(ticket.description)}</span>
        </Tooltip>
      </li>
      <li className="service__price">
        <PriceFormatter
          price={ticket.unitPrice}
        />
      </li>
      <li className="service__input">{input}</li>
    </ul>
  );
};

Ticket.PropTypes = {
  ticket:PropTypes.shape({
    description:PropTypes.string.isRequired,
    name:PropTypes.string.isRequired,
    serviceId:PropTypes.string.isRequired,
    unitCount:PropTypes.number.isRequired,
    maxUnits:PropTypes.number.isRequired,
    unitPrice:PropTypes.object.isRequired,
  }).isRequired,
  inputChange:PropTypes.func.isRequired,
};

export default Ticket;
